import React from 'react'

const NotFound = () => (
  <h1>Não encontrada</h1>
)

export default NotFound